import { m } from 'framer-motion';
// @mui
import Typography from '@mui/material/Typography';
// components
import { MotionContainer, varBounce } from 'src/components/animate';
// assets
import { PageNotFoundIllustration } from 'src/assets/illustrations';
import Box from '@mui/material/Box';

// ----------------------------------------------------------------------

export default function SomethingWentWrong() {
  return (
    <Box sx={{ margin: 'auto', p: 8, textAlign: 'center' }}>
      <MotionContainer>
        <m.div variants={varBounce().in}>
          <Typography variant="h3" paragraph>
            Something went wrong!
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Typography sx={{ color: 'text.secondary' }}>
            Sorry, something went wrong. Please try again later.
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <PageNotFoundIllustration
            sx={{
              height: 260,
              my: { xs: 5, sm: 10 },
            }}
          />
        </m.div>
      </MotionContainer>
    </Box>
  );
}
